















import { Component, Mixins, Prop } from "vue-property-decorator";
import { HeaderColumn } from "#/components/selectFilter/filter";
import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import AssignDialog from "./AssignDialog.vue";

type adminUser = {
  id: number;
  last_name: string;
  first_name: string;
  mail_address: string;
  auth_name: string;
};

@Component({
  components: {
    AppAuthButton,
    AssignDialog,
  },
})
export default class AssignForm extends Mixins(AxiosMixin) {
  /** アサイン情報 */
  @Prop({ default: () => ({}) }) assign!: {};

  /** 選択可能事業所のヘッダ */
  private headers: HeaderColumn[] = [
    { text: "姓", value: "last_name", sortable: true },
    { text: "名", value: "first_name", sortable: true },
    { text: "メールアドレス", value: "mail_address", sortable: true },
    { text: "権限名", value: "auth_name", sortable: true },
  ];

  /** ダイアログ表示フラグ */
  private dialog = false;

  /** アサイン処理 */
  private saveAssignMember(selectedRecords: adminUser[]) {
    // アサイン処理のロジックをここに追加
    this.postJsonCheck(
      window.base_url + "/api/admin/assign/save",
      {
        assign: this.assign,
        assign_admin_users: selectedRecords,
      },
      () => {
        this.$openAlert("メンバーを登録しました。");
        this.dialog = false;
      }
    );
  }
}
